import { render, staticRenderFns } from "./PriceSetting.vue?vue&type=template&id=42e72a50&scoped=true&"
import script from "./PriceSetting.vue?vue&type=script&lang=ts&"
export * from "./PriceSetting.vue?vue&type=script&lang=ts&"
import style0 from "./PriceSetting.vue?vue&type=style&index=0&id=42e72a50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e72a50",
  null
  
)

export default component.exports